import { FormatMask } from './FormatMask';

const formatSerializedId = (serializedId) => {
  const formatMask = new FormatMask();
  if (String(serializedId || '').startsWith('chatj10:')) return 'Chat J10';
  const number = serializedId == null ? '' : String(serializedId).replace('@c.us', '');

  return formatMask.setPhoneFormatMask(number)?.replace('+55', '🇧🇷');
};

export default formatSerializedId;
